<template>
  <div class="container" @click="close_detail">
    <div class="page">
      <div class="top-title">款式信息规格选择</div>
      <!-- 品牌选择 -->
      <div v-if="brand_list.length > 0" class="brand-select-section">
        <div class="brand-label">选择品牌</div>
        <select v-model="form_data_order.brand_name" class="brand-select">
          <option value="">请选择品牌</option>
          <option v-for="(item, index) in brand_list" :key="index" :value="item.name">
            {{ item.name }}
          </option>
        </select>
      </div>
      <template v-if="from === 'draft'">
        <div class="cate-no-box">
          <div class="custom-no">
            <div class="label">自定义款号</div>
            <input
              type="text"
              class="input"
              v-model="new_style_no"
              placeholder="非一稿多款情况下，请输入您自定义的款号,放空则由系统自动生成"
            />
          </div>
          <div class="other-items">
            <div class="label">款式名称</div>
            <div class="input">{{ design.name }}</div>
          </div>
          <div class="other-items">
            <div class="label">款式品类</div>
            <div class="input">{{ design.product_category_name }}</div>
          </div>
        </div>
      </template>

      <template v-if="design.is_multiple">
        <div class="tab-list">
          <div
            class="tab-item"
            v-for="(v, k) in design.children"
            :class="{ active: current_children === v.key }"
            @click="change_children(v.key)"
          >
            {{ v.name }}
          </div>
        </div>
        <div class="content-wrap">
          <div class="label-title">尺码选择({{ select_size_ids.length }})</div>
          <div class="spec-list" style="font-size: 16px">
            <div class="item-box">
              <div class="spec-item" v-for="(v, k) in select_size_ids" :key="k">
                {{ v }}
                <img
                  src="@/assets/images/design/icon-del.png"
                  alt=""
                  class="img icon-del cursor"
                  @click.stop="remove_selected_size(v)"
                />
              </div>
            </div>
            <div class="add-btn" @click="open_choose_size_popup">添加尺码</div>
          </div>

          <div class="label-title">
            颜色选择({{ available_color_list.length }})
          </div>
          <div class="spec-list" style="font-size: 16px">
            <div class="item-box">
              <div
                class="spec-item"
                v-for="(v, k) in available_color_list"
                :key="k"
              >
                <span v-if="v.rgb" :style="{backgroundColor: v.rgb}" class="img"></span>
                <img v-else :src="v.color_value | default_img" alt="" class="img" />
                <span class="color-name">{{ v.color_name_cn }}</span>
                <img
                  src="@/assets/images/design/icon-del.png"
                  alt=""
                  class="img icon-del cursor"
                  @click.stop="remove_selected_color(v.color_id)"
                />
              </div>
            </div>
            <div class="add-btn" @click="open_choose_color_popup">添加颜色</div>
          </div>

          <div class="label-title">已选择规格/颜色</div>
          <table class="table">
            <tr>
              <th class="size">尺码</th>
              <th
                class="color"
                v-for="(v, k) in available_color_list"
                :key="`color` + k"
              >
                <img
                  src="@/assets/images/icon-edit-pink.png"
                  alt=""
                  class="icon-edit cursor"
                  @click="open_modify_color_popup(v.color_id)"
                />
                {{ v.color_name }}(件)
              </th>
              <th
                class="complete"
                v-for="(v, k) in complete_list"
                :key="`complete` + k"
              >
                <img
                  src="@/assets/images/icon-edit-pink.png"
                  alt=""
                  class="icon-edit cursor"
                  @click="
                    open_modify_adjust_popup(v.field_key, v.field_name_cn)
                  "
                />
                {{ v.field_name_cn }}(cm)
              </th>
            </tr>
            <template v-for="(v, k) in table_data">
              <tr>
                <td>
                  <img
                    src="@/assets/images/icon-edit-pink.png"
                    alt=""
                    class="icon-edit cursor"
                    @click="open_modify_size_popup(v.size.size_key)"
                  />
                  {{ v.size.size_alias }}
                </td>
                <td
                  class="color"
                  v-for="(vv, kk) in v.color"
                  :key="`color` + kk"
                >
                  <input
                    class="input"
                    type="number"
                    min="0"
                    v-model="vv.quantity"
                  />
                </td>
                <td
                  class="complete"
                  v-for="(vv, kk) in v.complete"
                  :key="`complete` + kk"
                >
                  <input
                    class="input"
                    type="text"
                    v-model="vv.val"
                    @blur="blur($event, vv)"
                  />
                </td>
              </tr>
            </template>
          </table>
        </div>
      </template>
      <template v-else>
        <div class="label-title">尺码选择({{ select_size_ids.length }})</div>
        <div class="spec-list" style="font-size: 16px">
          <div class="item-box">
            <div class="spec-item" v-for="(v, k) in select_size_ids" :key="k">
              {{ v }}
              <img
                src="@/assets/images/design/icon-del.png"
                alt=""
                class="img icon-del cursor"
                @click.stop="remove_selected_size(v)"
              />
            </div>
          </div>
          <div class="add-btn" @click="open_choose_size_popup">添加尺码</div>
        </div>

        <div class="label-title">
          颜色选择({{ available_color_list.length }})
        </div>
        <div class="spec-list" style="font-size: 16px">
          <div class="item-box">
            <div
              class="spec-item"
              v-for="(v, k) in available_color_list"
              :key="k"
              :title="v.color_name_cn"
            >
              <img
                v-if="v.color_value"
                class="img"
                :src="v.color_value | default_img"
                alt=""
              />
              <span v-else class="img" :style="{ background: v.rgb }"></span>
              <span class="color-name">{{ v.color_name_cn }}</span>
              <img
                src="@/assets/images/design/icon-del.png"
                alt=""
                class="img icon-del cursor"
                style="width: 20px;height:20px;"
                @click.stop="remove_selected_color(v.color_id)"
              />
            </div>
          </div>
          <div class="add-btn" @click="open_choose_color_popup">添加颜色</div>
        </div>

        <div class="label-title">已选择规格/颜色</div>
        <table class="table">
          <tr>
            <th class="size">尺码</th>
            <th
              class="color"
              v-for="(v, k) in available_color_list"
              :key="`color` + k"
            >
              <img
                src="@/assets/images/icon-edit-pink.png"
                alt=""
                class="icon-edit cursor"
                @click="open_modify_color_popup(v.color_id)"
              />
              {{ v.color_name }}(件)
            </th>
            <th
              class="complete"
              v-for="(v, k) in complete_list"
              :key="`complete` + k"
            >
              <img
                src="@/assets/images/icon-edit-pink.png"
                alt=""
                class="icon-edit cursor"
                @click="open_modify_adjust_popup(v.field_key, v.field_name_cn)"
              />
              {{ v.field_name_cn }}(cm)
            </th>
          </tr>
          <template v-for="(v, k) in table_data">
            <tr>
              <td>
                <img
                  src="@/assets/images/icon-edit-pink.png"
                  alt=""
                  class="icon-edit cursor"
                  @click="open_modify_size_popup(v.size.size_key)"
                />
                {{ v.size.size_alias }}
              </td>
              <td class="color" v-for="(vv, kk) in v.color" :key="`color` + kk">
                <input
                  class="input"
                  type="number"
                  min="0"
                  v-model="vv.quantity"
                />
              </td>
              <td
                class="complete"
                v-for="(vv, kk) in v.complete"
                :key="`complete` + kk"
              >
                <input
                  class="input"
                  type="text"
                  v-model="vv.val"
                  @blur="blur($event, vv)"
                />
              </td>
            </tr>
          </template>
        </table>

        <!-- 大货订单显示包装方式和吊牌字段 -->
        <div v-if="from ==='design'" class="extra-fields-section">
          <div class="label-title">包装方式和吊牌</div>
          
          <div class="extra-field-group">
            <div class="field-row">
              <div class="field-label">包装方式说明：</div>
              <textarea 
                class="textarea extra-textarea" 
                v-model="form_data_packaging.package_description" 
                placeholder="请输入包装方式说明"
                rows="3"
              ></textarea>
            </div>
            <div class="field-row upload-row">
              <div class="field-label">包装方式附件：</div>
              <div class="upload-wrapper">
                <Upload
                  :action="''"
                  :multiple="true"
                  :before-upload="(file) => handleBeforeUpload(file, 'package')"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  :show-upload-list="false"
                >
                  <Button icon="ios-cloud-upload-outline">选择文件</Button>
                </Upload>
                <!-- 自定义文件列表显示 -->
                <div v-if="form_data_packaging.package_files.length > 0" class="custom-file-list">
                  <div 
                    v-for="(file, index) in form_data_packaging.package_files" 
                    :key="`pa`+index"
                    class="custom-file-item"
                  >
                    <span class="file-name">{{ file.name }}</span>
                    <span class="file-size">({{ formatFileSize(file.size) }})</span>
                    <Icon 
                      type="md-close" 
                      class="file-remove cursor" 
                      @click="removeFile('package', index)"
                      title="删除"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="extra-field-group">
            <div class="field-row">
              <div class="field-label">吊牌说明：</div>
              <textarea 
                class="textarea extra-textarea" 
                v-model="form_data_packaging.label_description" 
                placeholder="请输入吊牌说明"
                rows="3"
              ></textarea>
            </div>
            <div class="field-row upload-row">
              <div class="field-label">吊牌附件：</div>
              <div class="upload-wrapper">
                <Upload
                  :action="''"
                  :multiple="true"
                  :before-upload="(file) => handleBeforeUpload(file, 'label')"
                  accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                  :show-upload-list="false"
                >
                  <Button icon="ios-cloud-upload-outline">选择文件</Button>
                </Upload>
                <!-- 自定义文件列表显示 -->
                <div v-if="form_data_packaging.label_files.length > 0" class="custom-file-list">
                  <div 
                    v-for="(file, index) in form_data_packaging.label_files" 
                    :key="`la`+index"
                    class="custom-file-item"
                  >
                    <span class="file-name">{{ file.name }}</span>
                    <span class="file-size">({{ formatFileSize(file.size) }})</span>
                    <Icon 
                      type="md-close" 
                      class="file-remove cursor" 
                      @click="removeFile('label', index)"
                      title="删除"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </template>
    </div>
    <div class="page">
      <div class="big-title">款式明细</div>
      <div class="report" style="overflow: hidden">
        <div class="wrap">
          <div class="left">
            <div class="kuanshitu cell">
              <h3 class="title">款式图：</h3>
              <div class="image-list">
                <template v-for="(v, k) in design.image_list">
                  <img
                    v-if="util.test_image(v)"
                    :src="v"
                    :key="k"
                    alt=""
                    class="image-item"
                    v-viewer
                  />
                  <img
                    v-if="typeof v === 'object' && util.test_image(v.raw)"
                    :src="v.raw"
                    :key="k"
                    alt=""
                    class="image-item"
                    v-viewer
                  />
                </template>
              </div>
              <template v-for="(v, k) in design.image_list">
                <a
                  v-if="typeof v === 'object' && !util.test_image(v.raw)"
                  target="_blank"
                  :href="v.raw"
                  >{{ v.raw_name }}</a
                >
              </template>
              <div class="kuanshishuoming">
                <h3 class="title">款式说明：</h3>
                <p style="margin: 20px 10px">{{ design.description }}</p>
              </div>
            </div>
            <div class="banxing cell">
              <h3 class="title">版型文件：</h3>
              <p v-if="!!design.style_no_push">
                版型：{{ design.style_no_push }}
              </p>
              <p>类型：{{ design.pattern_type | get_pattern_type }}</p>
              <template v-for="(v, k) in design.pattern">
                <template v-if="design.pattern_type === 1">
                  <a class="file-item" :href="v.path" target="_blank">
                    {{ v.name }}
                  </a>
                </template>
                <template v-if="design.pattern_type === 2">
                  <a class="file-item" :href="v.path" target="_blank">
                    {{ v.name }}
                  </a>
                  <a class="file-item" :href="v.guige_path" target="_blank">
                    {{ v.guige_name }}
                  </a>
                </template>
                <template v-if="design.pattern_type === 3">
                  <p>场景：{{ v.c_scene }}</p>
                  <p>性别：{{ v.sex }}</p>
                  <p>类型：{{ v.c_type }}</p>
                  <p>说明：{{ v.c_content }}</p>
                </template>
              </template>
            </div>
            <div class="mianliao-cell cell">
              <h3 class="title">面料/里料明细：</h3>
              <div class="table">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>产品信息</th>
                      <th>颜色</th>
                      <th>成分</th>
                      <th>幅宽/克重</th>
                      <th>使用说明</th>
                      <th>是否寄样</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(v, k) in design.material" :key="`m` + k">
                      <td>{{ v.alias }}</td>
                      <td>
                        <div class="table-info">
                          <img
                            v-if="!!v.image"
                            :src="v.image"
                            alt=""
                            class="fa-img"
                            v-viewer
                          />
                          <div class="text">
                            <span class="fa-name">{{ v.fabric_name_cn }}</span>
                            <span class="fa-key">{{ v.fabric_key }}</span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="colors">
                          <img
                            class="color-image"
                            v-if="v.color_value"
                            :src="v.color_value"
                            v-viewer
                          />
                          <div class="color-name">{{ v.color_name_cn }}</div>
                        </div>
                      </td>
                      <td :title="v.component">{{ v.component }}</td>
                      <td :title="v.width_wide">{{ v.width_wide }}</td>
                      <td :title="v.desc">{{ v.desc }}</td>
                      <td>
                        <div class="sample">
                          <input
                            v-if="form_data_sample[v.id]"
                            tool-tip="不可选表示不支持寄样"
                            :disabled="
                              !(
                                form_data_sample[v.id] &&
                                form_data_sample[v.id].is_support_send_sample >
                                  0
                              )
                            "
                            :checked="!!form_data_sample[v.id].need_sample"
                            @change="toggle_sample(v.id)"
                            type="checkbox"
                          />
                        </div>
                      </td>
                    </tr>
                    <template v-if="design.is_material_self">
                      <tr
                        v-for="(item, index) in design.material_self"
                        :key="'ms' + index"
                      >
                        <td>
                          <div style="display: flex; align-items: center">
                            <span style="color: red">客</span>
                            <span>{{ item.alias }}</span>
                          </div>
                        </td>
                        <td>
                          <div class="table-info">
                            <img
                              v-if="!!item.image"
                              :src="item.image"
                              alt=""
                              class="fa-img"
                              v-viewer
                            />
                            <div class="text">
                              <span class="fa-name">
                                {{ item.fabric_name_cn }}
                              </span>
                              <span class="fa-key">{{ item.fabric_key }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="colors">
                            <img
                              class="color-image"
                              v-if="item.color_value"
                              :src="item.color_value"
                              v-viewer
                            />
                            <div class="color-name">
                              {{ item.color_name_cn }}
                            </div>
                          </div>
                        </td>
                        <td>{{ item.width_wide }}</td>
                        <td>{{ item.component }}</td>
                        <td>{{ item.desc }}</td>
                        <td>
                          <div class="sample">否</div>
                        </td>
                      </tr>
                    </template>
                    <template v-if="design.is_material_daigou">
                      <tr
                        v-for="(item, index) in design.material_daigou"
                        :key="'md' + index"
                      >
                        <td>
                          <div style="display: flex; align-items: center">
                            <span style="color: red">代</span>
                            <span>{{ item.alias }}</span>
                          </div>
                        </td>
                        <td>
                          <div class="table-info">
                            <img
                              v-if="!!item.image"
                              :src="item.image"
                              alt=""
                              class="fa-img"
                              v-viewer
                            />
                            <div class="text">
                              <span class="fa-name">
                                {{ item.fabric_name_cn }}
                              </span>
                              <span class="fa-key">{{ item.fabric_key }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="colors">
                            <img
                              class="color-image"
                              v-if="item.color_value"
                              :src="item.color_value"
                              v-viewer
                            />
                            <div class="color-name">
                              {{ item.color_name_cn || item.color_name }}
                            </div>
                          </div>
                        </td>
                        <td>{{ item.width_wide }}</td>
                        <td>{{ item.component }}</td>
                        <td>{{ item.desc }}</td>
                        <td>
                          <div class="sample">否</div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="fuliao-cell cell">
              <h3 class="title">辅料明细：</h3>
              <div class="table">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>产品信息</th>
                      <th>颜色</th>
                      <th>规格</th>
                      <th>使用数量</th>
                      <th>使用说明</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(v, k) in design.accessory" :key="`m` + k">
                      <td></td>
                      <td>
                        <div class="product-info">
                          <img
                            v-if="!!v.image"
                            :src="v.image"
                            alt=""
                            class="fa-img"
                            v-viewer
                          />
                          <div class="text">
                            <span class="fa-name">{{ v.accessory_name }}</span>
                            <span class="fa-key">{{ v.accessory_sku }}</span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div class="fuliao-colors">
                          <img
                            class="fuliao-color"
                            v-if="v.color_value"
                            :src="v.color_value"
                            v-viewer
                          />
                          <div class="fuliao-color-name">
                            {{ v.color_name_cn }}
                          </div>
                        </div>
                      </td>
                      <td>{{ v.measure_unit }}</td>
                      <td>{{ v.num }}</td>
                      <td>{{ v.desc }}</td>
                    </tr>
                    <template v-if="design.is_accessory_self">
                      <tr
                        v-for="(v, k) in design.accessory_self"
                        :key="`ass` + k"
                      >
                        <td>
                          <span style="color: red">客</span>
                        </td>
                        <td>
                          <div class="product-info">
                            <img
                              v-if="!!v.image"
                              :src="v.image"
                              alt=""
                              class="fa-img"
                              v-viewer
                            />
                            <div class="text">
                              <span class="fa-name">
                                {{ v.accessory_name }}
                              </span>
                              <span class="fa-key">{{ v.accessory_sku }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="fuliao-colors">
                            <img
                              class="fuliao-color"
                              v-if="v.color_value"
                              :src="v.color_value"
                              v-viewer
                            />
                            <div class="fuliao-color-name">
                              {{ v.color_name_cn }}
                            </div>
                          </div>
                        </td>
                        <td>{{ v.measure_unit }}</td>
                        <td>{{ v.num }}</td>
                        <td>{{ v.desc }}</td>
                      </tr>
                    </template>
                    <template v-if="design.is_accessory_daigou">
                      <tr
                        v-for="(v, k) in design.accessory_daigou"
                        :key="`asd` + k"
                      >
                        <td>
                          <span style="color: red">代</span>
                        </td>
                        <td>
                          <div class="product-info">
                            <img
                              v-if="!!v.image"
                              :src="v.image"
                              alt=""
                              class="fa-img"
                              v-viewer
                            />
                            <div class="text">
                              <span class="fa-name">
                                {{ v.accessory_name }}
                              </span>
                              <span class="fa-key">{{ v.accessory_sku }}</span>
                            </div>
                          </div>
                        </td>
                        <td>
                          <div class="fuliao-colors">
                            <img
                              class="fuliao-color"
                              v-if="v.color_value"
                              :src="v.color_value"
                              v-viewer
                            />
                            <div class="fuliao-color-name">
                              {{ v.color_name_cn || v.color_name }}
                            </div>
                          </div>
                        </td>
                        <td>{{ v.measure_unit }}</td>
                        <td>{{ v.num }}</td>
                        <td>{{ v.desc }}</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 增加尺码弹窗 -->
    <popup
      :show.sync="is_choose_size_popup_show"
      height="300px"
      width="960px"
      @on-close="close_choose_size_popup"
    >
      <div class="popup">
        <div class="title">尺码选择</div>
        <template v-if="[2, 3].includes(design.pattern_type)">
          <select
            class="group-list"
            v-model="current_group_id"
            @change="change_group"
          >
            <option
              v-for="(v, k) in raw_group_list"
              :value="v.id"
              :key="`size-group-${k}`"
            >
              {{ v.name }}
            </option>
          </select>
        </template>

        <div class="color-list size-list">
          <div
            class="color-item cursor"
            :class="{ active: temp_size_ids.includes(v) }"
            v-for="(v, k) in raw_size_list"
            @click="toggle_size(v)"
            :key="`size-${k}`"
          >
            <span>{{ v }}</span>
          </div>
        </div>
        <div class="btn-modify cursor" @click="confirm_choose_size_popup">
          确定
        </div>
      </div>
    </popup>
    <!-- 修改尺码名称弹窗 -->
    <popup
      :show.sync="is_modify_size_show"
      height="250px"
      width="520px"
      @on-close="close_modify_size_popup"
    >
      <div class="popup">
        <div class="title">尺码名称</div>
        <div class="form-group">
          <div class="label">自定义名称</div>
          <input class="input" v-model="form_data_custom_size.size_alias" />
        </div>
        <div class="tip">
          <span>温馨提示：</span>
          自定义名称信息会显示在吊牌、水洗标、领标等物料上，
          如果未填写会显示尺码名称。
        </div>
        <div class="btn-modify cursor" @click="confirm_modify_size">
          确认修改
        </div>
      </div>
    </popup>

    <!-- 增加颜色弹窗 -->
    <popup
      :show.sync="is_choose_color_popup_show"
      height="650px"
      width="960px"
      @on-close="close_choose_color_popup"
    >
      <div class="popup">
        <div class="title">面料颜色色号选择</div>
        <div class="color-list">
          <div
            class="color-item cursor"
            :class="{ active: temp_color_ids.includes(v.color_id) }"
            v-for="(v, k) in raw_color_list"
            :key="k"
            @click="toggle_color(v.color_id)"
            :title="v.color_name_cn"
          >
            <span v-if="v.rgb" class="img" :style="{ background: v.rgb }"></span>
            <img
              v-else
              :src="v.color_value | default_img"
              class="img"
              alt=""
            />
            <span class="color-name">{{ v.color_name_cn }}</span>
          </div>
          <div
            class="color-item cursor"
            :class="{ active: temp_color_ids.includes(v.color_id) }"
            v-for="(v, k) in custom_color"
            :key="`custom-${k}`"
            @click="toggle_color(v.color_id)"
            :title="v.color_name"
          >
          <img
              :src="v.color_value | default_img"
              class="img"
              alt=""
            />
            <span class="color-name">{{ v.color_name }}</span>
            <img
              v-if="custom_color.map((v) => v.color_id).includes(v.color_id)"
              src="@/assets/images/design/icon-del.png"
              alt=""
              class="img icon-del cursor"
              @click.stop="del_custom_color(v.color_id)"
            />
          </div>
        </div>
        <div class="btn-modify cursor" @click="confirm_choose_color_popup">
          确定
        </div>

        <div class="form-group">
          <div class="label">自定义添加颜色</div>
          <input class="input" v-model="form_data_custom_color.color_alias" />
          <div class="btn-add cursor" @click="add_custom_color">点击添加</div>
        </div>
        <div class="tip">
          <span>温馨提示：</span>
          自定义颜色信息会显示在吊牌、水洗标、领标等物料上，
          如果未填写会显示颜色名称。
        </div>
      </div>
    </popup>

    <!-- 修改尺码名称弹窗 -->
    <popup
      :show.sync="is_modify_color_show"
      height="250px"
      width="520px"
      @on-close="close_modify_color_popup"
    >
      <div class="popup">
        <div class="title">颜色名称</div>
        <div class="form-group">
          <div class="label">自定义名称</div>
          <input class="input" v-model="form_data_modify_color.color_name" />
        </div>
        <div class="tip">
          <span>温馨提示：</span>
          自定义名称信息会显示在吊牌、水洗标、领标等物料上，
          如果未填写会显示颜色色号。
        </div>
        <div class="btn-modify cursor" @click="confirm_modify_color">
          确认修改
        </div>
      </div>
    </popup>

    <!-- 修改调整量弹窗 -->
    <popup
      :show.sync="is_modify_adjust_show"
      height="250px"
      width="520px"
      @on-close="close_modify_adjust_popup"
    >
      <div class="popup">
        <div class="title">部位统一调整量</div>
        <div class="form-group">
          <div class="label">{{ form_data_adjust.name }}</div>
          <input class="input" v-model="form_data_adjust.val" />
        </div>
        <div class="btn-modify cursor" @click="confirm_modify_adjust">
          确认修改
        </div>
      </div>
    </popup>

    <div class="footer">
      <div class="footer-btn-wrap">
        <div
          class="btn btn-back"
          @click="$router.go(-1)"
          v-if="$route.query.from === 'draft'"
        >
          返回编辑
        </div>
        <div class="price-wrap" v-if="count <= 10">
          数量：×{{ count }}
          <span class="shu">|</span>
          费用总计：
          <span class="money2">￥{{ total_price | price_format }}</span>
          元
          <span class="btn-detail" @click.stop="show_detail"
            >查看明细 &gt;</span
          >
          <div class="detail-modal" v-show="is_detail_show">
            <div class="p-list">
              <div
                class="p-item"
                v-for="(v, k) in design.cost_list"
                :key="`dc` + k"
              >
                <div class="left">{{ v.title }}</div>
                <div class="right">
                  ￥{{
                    (v.key === "base"
                      ? v.amount * count +
                        sample_warehouse_fee +
                        sample_kefu_fee
                      : v.is_single
                      ? v.amount
                      : v.amount * count) | price_format
                  }}
                </div>
              </div>
              <div class="p-item" v-if="sample_price > 0">
                <div class="left">寄样费用</div>
                <div class="right">￥{{ sample_price | price_format }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="price-wrap" v-if="count > 10">
          数量：×{{ count }}
        </div>
        <div class="btn btn-confirm" style="margin-left: 10px;"@click="submit">确认款式信息</div>
      </div>
      <div class="tips" v-if="count <= 10">
        说明:该费用只包含款式基础制作费用,如涉及印绣花,特殊工艺等,待客服确认后另行支付,敬请知悉!
      </div>
    </div>
  </div>
</template>

<script>
import {
  CreateOrder,
  GetDesign,
  GetDraft,
  GetUserBrandList,
  MtmFields,
  Profile,
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import util from "@/utils/util";
import axios from "axios";
import { mapState } from "vuex";
import { uploadFileToOSS } from "@/utils/oss";

export default {
  name: "Summary",
  components: {
    Popup,
  },
  filters: {
    get_pattern_type(v) {
      if (v === 1) {
        return "平台版型";
      } else if (v === 2) {
        return "客供版型";
      } else if (v === 3) {
        return "定制版型";
      } else {
        return "";
      }
    },
  },
  data() {
    return {
      util: util,
      is_detail_show: false,
      is_click: false,
      design: {
        tech: {},
        cost_list: [],
        material: [],
      },
      // 约等于要提交的表单数据
      table_data: {
        // {size: {size_key:'', size_alias: ''},color: {}, complete: {}}
      },
      // 成衣部位数据
      complete_list: [],
      current_group_id: 0,
      // 可选尺码分组
      raw_group_list: [
        {
          name: "请选择",
          id: 0,
          size_list: [],
        },
      ],
      // 所有尺码数据
      raw_size_list: [],
      // 已选尺码KEY
      temp_size_ids: [],
      select_size_ids: [],
      // 主面料A的颜色数据
      raw_color_list: [
        {
          color_id: -1,
          color_key: -1,
          color_name: "默认色",
          color_name_cn: "默认色",
          color_value: "",
        },
      ],
      // 自定义颜色数据
      custom_color: [],
      temp_color_ids: [],
      // 已选颜色ID
      select_color_ids: [],
      // 是否寄样数据
      form_data_sample: {},
      // 页面来源，草稿提交和款式再次下单
      from: "",
      // 仅来自草稿提交时有效
      new_style_no: "",
      is_choose_size_popup_show: false,
      is_modify_size_show: false,
      form_data_custom_size: {
        size_key: "",
        size_alias: "",
      },
      is_choose_color_popup_show: false,
      form_data_custom_color: {
        id: 0,
        color_alias: "",
      },
      is_modify_color_show: false,
      form_data_modify_color: {
        color_id: 0,
        color_name: "",
      },
      // 一稿多款
      current_children: "",
      form_data_multiple: {},
      user_fields: {},
      field_list: [],
      is_modify_adjust_show: false,
      form_data_adjust: {
        key: "",
        val: 0,
      },
      form_data_order: {
        brand_name: ''
      },
      brand_list: [],
      // 额外字段数据（包装方式和吊牌）
        form_data_packaging: {
          package_description: '',
          package_files: [],
          label_description: '',
          label_files: [],
        },
        // 上传队列和防抖定时器
        uploadQueue: [],
        debounceTimer: null,
        debounceTime: 300, // 防抖时间（毫秒）
        currentUploadType: '' // 当前上传的类型（packaging或label）
    };
  },
  computed: {
    ...mapState({
      setting: (state) => state.setting,
    }),
    material_map() {
      let obj = {};
      for (let i in this.design.material) {
        obj[this.design.material[i].id] = this.design.material[i];
      }
      return obj;
    },
    sample_price() {
      let price = 0;
      for (let i in this.form_data_sample) {
        if (this.form_data_sample[i].need_sample > 0) {
          price += parseFloat(this.form_data_sample[i].sample_price);
        }
      }
      const tax_ratio = Number(this.setting && this.setting.tax_ratio ? this.setting.tax_ratio : 0) || 0;
      return Math.ceil(price * (1 + tax_ratio / 100) * 1.1);
    },
    sample_warehouse_fee() {
      let raw = Array.from(this.setting.kw_price);
      let arr = Array.isArray(raw) ? raw.reverse() : [];
      let p = 0;
      for (let i in arr) {
        if (
          Number(arr[i].min) <
            Number(this.design?.productcategory?.base_price) &&
          Number(this.design?.productcategory?.base_price) <= Number(arr[i].max)
        ) {
          p = arr[i]?.sample_warehouse_fee;
          break;
        }
      }
      return Math.ceil(p);
    },
    sample_kefu_fee() {
      let raw = Array.from(this.setting.kw_price);
      let arr = Array.isArray(raw) ? raw.reverse() : [];
      let p = 0;
      for (let i in arr) {
        if (
          Number(arr[i].min) <
            Number(this.design?.productcategory?.base_price) &&
          Number(this.design?.productcategory?.base_price) <= Number(arr[i].max)
        ) {
          p = arr[i]?.sample_kefu_fee;
          break;
        }
      }
      return Math.ceil(p);
    },
    total_price() {
      let once_price = this.design.cost_list
        .filter((v) => v.is_single)
        .map((v) => v.amount)
        .reduce((a, b) => a + b, 0);
      return (
        this.design.factory_price * this.count +
        parseFloat(once_price) +
        parseFloat(this.sample_price) +
        parseFloat(this.sample_warehouse_fee) +
        parseFloat(this.sample_kefu_fee)
      );
    },
    count() {
      let res = 0;
      if (this.design.is_multiple) {
        for (let uuid in this.form_data_multiple) {
          const table_data = this.form_data_multiple[uuid].table_data;
          for (let i in table_data) {
            for (let j in table_data[i].color) {
              res += parseInt(table_data[i].color[j].quantity || 0);
            }
          }
        }
      } else {
        for (let i in this.table_data) {
          for (let j in this.table_data[i].color) {
            res += parseInt(this.table_data[i].color[j].quantity || 0);
          }
        }
      }

      return res;
    },
    available_color_list() {
      let arr1 = this.raw_color_list.filter((v) =>
        this.select_color_ids.includes(v.color_id),
      );
      let arr2 = this.custom_color.filter((v) =>
        this.select_color_ids.includes(v.color_id),
      )
      let arr = [...arr1, ...arr2];

      return arr;
    },
    available_color_list_multiple() {
      let obj = {};
      if (this.design.is_multiple) {
        for (let idx in this.design.children) {
          const arr1 = this.raw_color_list.filter((v) =>
            this.form_data_multiple[
              this.design.children[idx].key
            ].select_color_ids.includes(v.color_id),
          );
          const arr2 = this.custom_color.filter((v) =>
            this.form_data_multiple[
              this.design.children[idx].key
            ].select_color_ids.includes(v.color_id),
          );
          obj[this.design.children[idx].key] = [...arr1, ...arr2];
        }
      }

      return obj;
    },
  },
  async mounted() {
    this.from = this.$route.query.from;
    if (this.$route.query.uuid) {
      let response =
        this.from === "design"
          ? await GetDesign({ uuid: this.$route.query.uuid })
          : await GetDraft({ uuid: this.$route.query.uuid });
      this.design = response.data;
      // 初始化一稿多款结构
      if (this.design.is_multiple) {
        for (let i in this.design.children) {
          this.$set(this.form_data_multiple, this.design.children[i].key, {
            table_data: {},
            select_size_ids: [],
            select_color_ids: [],
          });
        }
      }
      // 处理默认选择的颜色
      let obj = this.design.material.find((v) => v.alias === "面料A");
      let color_id = null;
      if (obj && obj.color_list.length > 0) {
        this.raw_color_list = this.$_.cloneDeep(obj.color_list);
        if (obj.color_key) {
          let c = this.raw_color_list.find((v) => v.color_key == obj.color_key);
          if (c) {
            color_id = c.color_id;
          } else {
            color_id = this.raw_color_list[0].color_id;
          }
        } else {
          color_id = this.raw_color_list[0].color_id;
        }
      } else {
        color_id = this.raw_color_list[0].color_id;
      }
      this.choose_color(color_id);

      if (this.design.pattern_type === 1) {
        this.raw_size_list = this.design?.pat?.size_list || [];
        this.complete_list = this.design?.pat?.field_list || [];
        // 处理默认选择的尺码
        let s = this.raw_size_list[Math.floor(this.raw_size_list.length / 2)];
        this.choose_size(s);
      } else if (this.design.pattern_type === 2) {
        // 自供版型情况
        if (this.design.pattern[0].sex == "男") {
          let g = this.design.productcategory.size_group_list.find(
            (v) => v.key === "男",
          );
          this.raw_group_list = g
            ? [...this.raw_group_list, ...g.group]
            : undefined;
        }
        if (this.design.pattern[0].sex == "女") {
          let g = this.design.productcategory.size_group_list.find(
            (v) => v.key === "女",
          );
          this.raw_group_list = g
            ? [...this.raw_group_list, ...g.group]
            : undefined;
        }
      } else if (this.design.pattern_type === 3) {
        // 定制版型情况
        this.complete_list = this.design.productcategory.field_list;
        if (this.design.pattern[0].sex == "男") {
          let g = this.design.productcategory.size_group_list.find(
            (v) => v.key === "男",
          );
          this.raw_group_list = g
            ? [...this.raw_group_list, ...g.group]
            : undefined;
        }
        if (this.design.pattern[0].sex == "女") {
          let g = this.design.productcategory.size_group_list.find(
            (v) => v.key === "女",
          );
          this.raw_group_list = g
            ? [...this.raw_group_list, ...g.group]
            : undefined;
        }
      }
      if (this.design.is_multiple) {
        for (let i in this.design.children) {
          this.change_children(this.design.children[i].key);
          this.choose_color(color_id);
          if (this.design.pattern_type === 1) {
            // 处理默认选择的尺码
            let s =
              this.raw_size_list[Math.floor(this.raw_size_list.length / 2)];
            this.choose_size(s);
          }
        }
        this.change_children(this.design.children[0].key);
      }

      // 记录面料是否选择寄样服务
      for (let i in this.design.material) {
        this.$set(this.form_data_sample, this.design.material[i].id, {
          is_support_send_sample:
            this.design.material[i].is_support_send_sample,
          need_sample: 0,
          sample_price: this.design.material[i].sample_price,
        });
      }
    }

    axios.all([this.getProfile(), MtmFields()]).then(
      axios.spread((response1, response2) => {
        this.field_list = response2.data;
        if (response1.data.yjld) {
          this.user_fields = response1.data.yjld;
        }
        for (let i in response2.data) {
          if (!this.$_.has(this.user_fields, response2.data[i].field_key)) {
            this.$set(this.user_fields, response2.data[i].field_key, 0);
          }
        }
      }),
    );
    this.getUserBrandList();
  },
  methods: {
    async getUserBrandList() {
      try {
        const { data } = await GetUserBrandList({ status: 'pass' });
        if (data) {
          this.brand_list = data;
          if (data.length > 0) {
            this.form_data_order.brand_name = data[0].name;
          }
        }
      } catch (e) {
        console.log("err-get-user-brand-list", e);
      }
    },
    toggle_sample(id) {
      let obj = this.form_data_sample[id]
      obj.need_sample = obj.need_sample ? 0 : 1;
      this.$set(
        this.form_data_sample,
        id,
        obj,
      );
    },
    change_group($event) {
      console.log(111, this.current_group_id, this.raw_group_list);
      let g = this.raw_group_list.find((v) => v.id === this.current_group_id);
      this.raw_size_list = g ? g.size_list : [];
    },
    change_children(key) {
      // 先保存之前的数据
      if (this.current_children) {
        this.$set(this.form_data_multiple, this.current_children, {
          table_data: this.table_data,
          select_size_ids: this.select_size_ids,
          select_color_ids: this.select_color_ids,
        });
      }
      // 再把当前的换出来
      this.current_children = key;
      this.select_color_ids = this.form_data_multiple[key]
        ? this.form_data_multiple[key].select_color_ids
        : [];
      this.select_size_ids = this.form_data_multiple[key]
        ? this.form_data_multiple[key].select_size_ids
        : [];
      this.table_data = this.form_data_multiple[key]
        ? this.form_data_multiple[key].table_data
        : {};
      this.current_group_id = 0;
      if (this.design.pattern_type != 1) {
        this.raw_size_list = [];
      }
    },
    blur($e, v) {
      let temp = $e.target.value;
      if (isNaN(temp)) {
        v.val = v.normal;
      }
      temp = parseFloat(temp);
      if (temp < parseFloat(v.normal) + parseFloat(v.min)) {
        v.val = parseFloat(v.normal) + parseFloat(v.min);
      }
      if (temp > parseFloat(v.normal) + parseFloat(v.max)) {
        v.val = parseFloat(v.normal) + parseFloat(v.max);
      }
      v.val = Math.round(v.val * 10) / 10;
    },
    toggle_color(color_id) {
      if (this.temp_color_ids.includes(color_id)) {
        this.temp_color_ids = this.temp_color_ids.filter((item) => {
          return item !== color_id;
        });
      } else {
        this.temp_color_ids.push(color_id);
        this.temp_color_ids = [...new Set(this.temp_color_ids)];
      }
    },
    confirm_choose_color_popup() {
      this.temp_color_ids.forEach((v) => {
        if (!this.select_color_ids.includes(v)) {
          this.choose_color(v);
        }
      });
      this.temp_color_ids = [];
      this.is_choose_color_popup_show = false;
    },
    choose_color(color_id) {
      if (this.select_color_ids.includes(color_id)) {
        this.select_color_ids = this.select_color_ids.filter((item) => {
          return item !== color_id;
        });
      } else {
        this.select_color_ids.push(color_id);
        this.select_color_ids = [...new Set(this.select_color_ids)];
      }
      for (let i in this.table_data) {
        let obj = this.table_data[i];

        if (this.$_.has(obj.color, color_id)) {
          delete obj.color[color_id];
        } else {
          let color = this.available_color_list.find(
            (v) => v.color_id === color_id,
          );
          obj.color[color_id] = { ...color, quantity: 0 };
        }
        this.$set(this.table_data, i, this.$_.cloneDeep(obj));
      }
    },
    open_modify_color_popup(color_id) {
      this.is_modify_color_show = true;
      this.form_data_modify_color.color_id = color_id;
      this.form_data_modify_color.color_name = "";
    },
    close_modify_color_popup() {
      this.is_modify_color_show = false;
    },
    confirm_modify_color() {
      if (this.form_data_modify_color.color_name.length > 4) {
        this.$layer.msg(`不超过4个字符`);
        return;
      }
      let idx = this.raw_color_list.findIndex(
        (v) => v.color_id === this.form_data_modify_color.color_id,
      );
      if (idx > -1) {
        this.$set(this.raw_color_list, idx, {
          ...this.raw_color_list[idx],
          color_name: this.form_data_modify_color.color_name,
        });
      }
      let idx2 = this.custom_color.findIndex(
        (v) => v.color_id === this.form_data_modify_color.color_id,
      );
      if (idx2 > -1) {
        this.$set(this.custom_color, idx2, {
          ...this.custom_color[idx2],
          color_name: this.form_data_modify_color.color_name,
          color_name_cn: this.form_data_modify_color.color_name,
        });
      }
      this.is_modify_color_show = false;
    },
    open_choose_color_popup() {
      this.is_choose_color_popup_show = true;
      this.form_data_custom_color.id = 0;
      this.form_data_custom_color.color_alias = "";
    },
    close_choose_color_popup() {
      this.is_choose_color_popup_show = false;
    },
    add_custom_color() {
      if (this.form_data_custom_color.color_alias.length === 0) {
        this.$layer.msg(`请填写自定义名称`);
        return;
      }
      if (this.form_data_custom_color.color_alias.length > 4) {
        this.$layer.msg(`不超过4个字符`);
        return;
      }
      let uuid = util.uuid().toUpperCase();
      let obj = {
        color_id: uuid,
        color_key: uuid,
        color_name: this.form_data_custom_color.color_alias,
        color_name_cn: this.form_data_custom_color.color_alias,
        color_value: "",
        type: 1,
      };
      this.custom_color.push(obj);
      this.temp_color_ids.push(obj.color_id);
      this.form_data_custom_color.id = 0;
      this.form_data_custom_color.color_alias = "";
    },
    del_custom_color(color_id) {
      let idx1 = this.custom_color.findIndex((v) => v.color_id === color_id);
      this.custom_color.splice(idx1, 1);
      this.choose_color(color_id);
    },
    remove_selected_color(color_id) {
      let idx1 = this.custom_color.findIndex((v) => v.color_id === color_id);
      if (idx1 > -1) {
        this.choose_color(color_id);
      }
      let idx2 = this.raw_color_list.findIndex((v) => v.color_id === color_id);
      if (idx2 > -1) {
        this.choose_color(color_id);
      }
    },
    toggle_size(size_key) {
      if (this.temp_size_ids.includes(size_key)) {
        this.temp_size_ids = this.temp_size_ids.filter((item) => {
          return item !== size_key;
        });
      } else {
        this.temp_size_ids.push(size_key);
        this.temp_size_ids = [...new Set(this.temp_size_ids)];
      }
    },
    confirm_choose_size_popup() {
      this.temp_size_ids.forEach((v) => {
        if (!this.select_size_ids.includes(v)) {
          this.choose_size(v);
        }
      });
      this.temp_size_ids = [];
      this.is_choose_size_popup_show = false;
    },
    choose_size(size_key) {
      if (this.select_size_ids.includes(size_key)) {
        this.select_size_ids = this.select_size_ids.filter((item) => {
          return item !== size_key;
        });
      } else {
        this.select_size_ids.push(size_key);
        this.select_size_ids = [...new Set(this.select_size_ids)];
      }
      let obj = this.table_data;
      if (this.$_.has(obj, size_key)) {
        delete obj[`${size_key}`];
        this.$set(this, "table_data", obj);
      } else {
        let temp_color = {};
        for (let ii in this.select_color_ids) {
          let color = this.available_color_list.find(
            (v) => v.color_id === this.select_color_ids[ii],
          );
          temp_color[this.select_color_ids[ii]] = { ...color, quantity: 0 };
        }
        let temp_complete = this.$_.cloneDeep(
          this.design?.pat?.size_info[size_key] || {},
        );
        if (this.design.pattern_type === 3) {
          // 定制版型情况
          temp_complete = this.$_.cloneDeep(
            this.design?.productcategory?.size_info[size_key] || {},
          );
        }
        for (let i in temp_complete) {
          if (!this.$_.has(temp_complete[i], "val")) {
            temp_complete[i].val = temp_complete[i].normal;
          }
        }
        this.$set(
          this.table_data,
          size_key,
          this.$_.cloneDeep({
            size: { size_key: size_key, size_alias: size_key },
            color: temp_color,
            complete: temp_complete,
            sort: this.raw_size_list.findIndex((v) => v === size_key),
            group_id: this.current_group_id,
          }),
        );
      }

      const map = new Map(
        Object.entries(this.table_data).sort(function (a, b) {
          if (a[1].group_id - b[1].group_id <= 0) {
            return a[1].sort - b[1].sort;
          } else {
            return false;
          }
        }),
      );
      this.$set(this, "table_data", Object.fromEntries(map));
      if (this.design.is_multiple) {
        this.change_children(this.current_children);
      }
    },
    open_choose_size_popup() {
      this.is_choose_size_popup_show = true;
    },
    close_choose_size_popup() {
      this.is_choose_size_popup_show = false;
    },
    open_modify_size_popup(size) {
      this.is_modify_size_show = true;
      this.form_data_custom_size.size_key = size;
      this.form_data_custom_size.size_alias = "";
    },
    close_modify_size_popup() {
      this.is_modify_size_show = false;
    },
    confirm_modify_size() {
      if (this.form_data_custom_size.size_alias.length > 10) {
        this.$layer.msg(`不超过10个字符`);
        return;
      }
      this.$set(
        this.table_data[this.form_data_custom_size.size_key].size,
        "size_alias",
        this.form_data_custom_size.size_alias,
      );
      this.is_modify_size_show = false;
    },
    remove_selected_size(size_key) {
      this.choose_size(size_key);
    },
    open_modify_adjust_popup(key, name) {
      this.is_modify_adjust_show = true;
      this.form_data_adjust.key = key;
      this.form_data_adjust.name = name;
      this.form_data_adjust.val = this.user_fields[key];
    },
    close_modify_adjust_popup() {
      this.is_modify_adjust_show = false;
    },
    confirm_modify_adjust() {
      if (isNaN(this.form_data_adjust.val)) {
        this.$layer.msg(`调整量需要是数字`);
        return;
      }
      this.$set(
        this.user_fields,
        this.form_data_adjust.key,
        this.form_data_adjust.val,
      );
      for (let i in this.table_data) {
        let obj = this.table_data[i];
        for (let j in obj.complete) {
          if (this.form_data_adjust.key === j) {
            let after_val =
              parseFloat(obj.complete[j].normal) +
              parseFloat(this.form_data_adjust.val);
            if (
              after_val >
              parseFloat(obj.complete[j].normal) +
                parseFloat(obj.complete[j].max)
            ) {
              obj.complete[j].val =
                parseFloat(obj.complete[j].normal) +
                parseFloat(obj.complete[j].max);
            } else if (
              after_val <
              parseFloat(obj.complete[j].normal) +
                parseFloat(obj.complete[j].min)
            ) {
              obj.complete[j].val =
                parseFloat(obj.complete[j].normal) +
                parseFloat(obj.complete[j].min);
            } else {
              obj.complete[j].val = after_val;
            }
            obj.complete[j].val = Math.round(obj.complete[j].val * 10) / 10;
          }
        }
        this.$set(this.table_data, i, this.$_.cloneDeep(obj));
      }
      this.is_modify_adjust_show = false;
    },
    show_detail() {
      this.is_detail_show = true;
    },
    close_detail() {
      this.is_detail_show = false;
    },
    submit() {
      if (this.is_click) {
        return;
      }

      if (this.select_size_ids.length === 0) {
        this.$layer.msg(`请选择尺码`);
        return;
      }
      if (this.select_color_ids.length === 0) {
        this.$layer.msg(`请选择颜色`);
        return;
      }
      if (this.count < 1) {
        this.$layer.msg(`请输入所需定制服装的数量`);
        return;
      }

      if (!this.new_style_no && this.from === "draft") {
        this.$DModal.confirm({
          content: "将由平台自动生成款号，是否同意？",
          onOK: async () => {
            this.confirm_submit();
          },
        });
      } else {
        this.confirm_submit();
      }
    },
    async confirm_submit() {
      if (this.new_style_no) {
        const regex = /^[a-zA-Z0-9]+$/;
        if (!regex.test(this.new_style_no)) {
          this.$layer.msg('自定义款号只能包含字母和数字');
          return;
        }
      }
      this.is_click = true;
      const param = {};
      param.from = this.$route.query.from;
      param.new_style_no = this.new_style_no;
      param.uuid = this.$route.query.uuid;
      param.sample_extra = this.form_data_sample;
      param.form_data = this.table_data;
      param.color_list = this.available_color_list;
      param.form_data_multiple = this.form_data_multiple;
      param.color_list_multiple = this.available_color_list_multiple;
      param.user_fields = this.user_fields;
      param.form_data_packaging = this.form_data_packaging;
      CreateOrder({...param, ...this.form_data_order})
        .then((response) => {
          this.$router.replace({
            name: "WorkBenchCheckout",
            query: { uuid: response.data.uuid },
          });
        })
        .catch((res) => {
          this.$layer.msg(res.msg);
        })
        .finally(() => {
          setTimeout(() => {
            this.is_click = false;
          }, 500);
        });
    },
    async getProfile() {
      return Profile().then((response) => {
        return response;
      });
    },
    // 格式化文件大小
      formatFileSize(bytes) {
        if (!bytes || bytes === 0) return '0 B';
        const k = 1024;
        const sizes = ['B', 'KB', 'MB', 'GB'];
        const i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i];
      },
      // 删除文件
      removeFile(type, index) {
        if (type === 'package') {
          const list = this.form_data_packaging.package_files || [];
          list.splice(index, 1);
          this.$set(this.form_data_packaging, 'package_files', list);
        } else if (type === 'label') {
          const list = this.form_data_packaging.label_files || [];
          list.splice(index, 1);
          this.$set(this.form_data_packaging, 'label_files', list);
        }
        this.$layer.msg('删除成功');
      },
      // 清理附件数据，只保留文件名和文件地址
      cleanAttachmentData(fileList) {
        return (fileList || []).map(file => ({
          name: file.name,
          path: file.url,
        }));
      },
      // 处理批量上传文件
      async processAllFiles() {
        const queue = [...this.uploadQueue];
        const type = this.currentUploadType;
        
        this.uploadQueue = []; // 清空队列
        this.currentUploadType = '';

        console.log(`开始上传 ${queue.length} 个文件...`);

        for (const file of queue) {
          try {
            const url = await uploadFileToOSS(file, 'template');
            
            // 创建文件数据对象
            const fileData = {
              uid: util.uuid(),
              name: file.name,
              size: file.size,
              type: file.type,
              url: url,
            };
            
            if (type === 'package') {
              const currentList = this.form_data_packaging.package_files || [];
              this.$set(this.form_data_packaging, 'package_files', [...currentList, fileData]);
            } else if (type === 'label') {
              const currentList = this.form_data_packaging.label_files || [];
              this.$set(this.form_data_packaging, 'label_files', [...currentList, fileData]);
            }
            
            console.log('文件上传成功:', file.name, url);
          } catch (err) {
            console.error('上传失败:', err);
            if (err.code === 'IMAGE_SIZE_LIMIT') {
              this.$layer.msg(`图片【${file.name}】像素超过限制,最大宽度不能超过4096或者总体像素值不能超过9437184`);
              return;
            }
            this.$layer.msg(`上传失败：${file.name}`);
          }
        }
        
        if (queue.length > 0) {
          this.$layer.msg(`成功上传 ${queue.length} 个文件`);
        }
      },
      // 上传前校验和处理（批量上传模式）
      handleBeforeUpload(file, type) {
        console.log("file-before", file);
        
        // 文件类型校验
        const allowedTypes = ['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png'];
        const fileExt = '.' + file.name.split('.').pop().toLowerCase();
        
        if (!allowedTypes.includes(fileExt)) {
          this.$layer.msg('只能上传 pdf、doc、docx、jpg、jpeg、png 格式的文件!');
          return false;
        }
        
        // 文件大小校验（10MB）
        const isLt10M = file.size / 1024 / 1024 < 10;
        if (!isLt10M) {
          this.$layer.msg('上传文件大小不能超过 10MB!');
          return false;
        }
        
        // 将文件加入队列
        this.uploadQueue.push(file);
        this.currentUploadType = type;

        // 清除旧定时器
        if (this.debounceTimer) {
          clearTimeout(this.debounceTimer);
        }

        // 设置新定时器：如果一段时间内没有新文件进来，则开始上传
        this.debounceTimer = setTimeout(() => {
          this.processAllFiles();
        }, this.debounceTime);
        
        return false; // 阻止默认上传行为
      },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      // 通过 `vm` 访问组件实例
      vm.$emit("showFooter", false);
    });
  },
  beforeRouteLeave(to, from, next) {
    this.$emit("showFooter", true);
    next();
  },
};
</script>

<style lang="scss" scoped>
::-webkit-scrollbar {
  display: none !important;
}
.table::-webkit-scrollbar {
  display: block !important;
  height: 8px;
}
.table::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}
.table::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.container {
  background: #f6f7fa;
  padding: 30px 0 150px 0;

  .page {
    width: 1400px;
    margin: 20px auto;
    background: white;
    padding: 40px 50px;
    border-radius: 5px;
    overflow: hidden;
    .top-title {
      width: 100%;
      font-weight: bold;
      font-size: 20px;
      color: #333333;
      border-bottom: 1px solid #ebebeb;
      padding-bottom: 20px;
    }
    .cate-no-box {
      display: flex;
      align-items: center;
      column-gap: 20px;
      margin-top: 20px;
      .custom-no {
        display: flex;
        flex-direction: column;
        flex: 1;
        .label {
          font-weight: bold;
          color: #1a1a1a;
          font-size: 15px;
          &::before {
            content: "*";
            color: #fa3d5a;
          }
        }
        .input {
          width: 100%;
          height: 52px;
          line-height: 52px;
          border: 1px solid #dad5d1;
          border-radius: 5px;
          padding: 0 24px;
          outline: none;
        }
      }
      .other-items {
        display: flex;
        flex-direction: column;
        flex: 1;
        width: 100%;
        max-width: 300px;
        .label {
          font-weight: bold;
          color: #1a1a1a;
          font-size: 15px;
        }
        .input {
          width: 100%;
          max-width: 300px;
          height: 52px;
          line-height: 52px;
          border: 1px solid #dad5d1;
          border-radius: 5px;
          padding: 0 24px;
        }
      }
    }

    .tab-list {
      margin-top: 20px;
      display: flex;
      align-items: flex-end;
      .tab-item {
        width: 120px;
        height: 40px;
        line-height: 40px;
        color: #4d4d4d;
        font-size: 15px;
        margin: 0 2px;
        padding: 0 5px;
        background: #f4f6f5;
        border-radius: 10px 10px 0 0;
        text-align: center;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        &:first-child {
          margin-left: 0;
        }
        &.active {
          position: relative;
          top: 1px;
          height: 46px;
          line-height: 46px;
          color: #fa3d5a;
          font-size: 14px;
          font-weight: bold;
          border: 1px solid #808080;
          border-bottom: 1px solid white;
          background: white;
        }
      }
    }

    .content-wrap {
      width: 100%;
      padding: 20px;
      margin-bottom: 20px;
      background: #ffffff;
      border-radius: 0px 10px 10px 10px;
      border: 1px solid #808080;
    }

    .label-title {
      color: #1a1a1a;
      font-weight: bold;
      font-size: 15px;
      margin-top: 25px;
      margin-bottom: 14px;
    }

    .big-title {
      color: #333333;
      padding-bottom: 20px;
      font-size: 20px;
      font-weight: bold;
      // text-align: center;
    }

    .title {
      position: relative;
      color: #333333;
      border-left: 3px solid #fa3d5a;
      font-size: 16px;
      margin: 10px 0;
      padding-left: 8px;
      height: 15px;
      line-height: 15px;

      .tip {
        font-size: 12px;
        color: #4d4d4d;
      }

      .btn-add {
        position: absolute;
        top: 5px;
        right: 0;
        color: #4d4d4d;
        font-size: 13px;
      }
    }

    .spec-list {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      column-gap: 10px;
      border: 1px solid #dad5d1;
      border-radius: 5px;
      .item-box {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        flex: 1;
        .spec-item {
          position: relative;
          margin: 10px;
          padding-right: 10px;
          width: 100px;
          height: 38px;
          padding: 0 5px;
          background: #f5f5f5;
          text-align: center;
          font-size: 14px;
          color: #1a1a1a;
          border-radius: 5px;
          display: flex;
          justify-content: space-around;
          align-items: center;
          column-gap: 5px;
          .color-name {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .img {
            width: 26px;
            height: 26px;
            flex-shrink: 0;
            &.icon-del {
              position: absolute;
              top: 3px;
              right: 3px;
              width: 16px;
              height: 16px;
              z-index: 100;
            }
          }
        }
      }
      .add-btn {
        // width:70px;
        margin-right: 20px;
        background: #fbe8eb;
        border-radius: 14px;
        color: #fa3d5a;
        font-size: 12px;
        padding: 8px 12px;
        flex-shrink: 0;
        cursor: pointer;
      }
    }

    .style-no {
      padding: 0 20px;
      font-size: 16px;
      height: 40px;
      line-height: 40px;
      border: 1px solid #dad5d1;
      border-radius: 5px;
      outline: none;
      flex: 1;
    }

    .report {
      border: 1px solid #808080;

      .cell {
        padding: 11px 20px;
        /*border-top: 1px solid #808080;*/
        border-bottom: 1px solid #808080;
        font-size: 14px;
      }

      .border-top {
        border-top: 1px solid #808080;
      }

      .border-right {
        border-right: 1px solid #808080;
      }

      .border-right-no {
        border-right: none !important;
      }

      .border-bottom-no {
        border-bottom: none !important;
      }

      .row {
        display: flex;
        align-items: center;
        width: 100%;
        height: 50px;
        overflow: hidden;

        .cell {
          color: #666;

          span {
            font-weight: bold;
            color: #333;
          }
        }
      }

      .wrap {
        display: flex;
        flex-wrap: nowrap;

        .left {
          // width: 920px;
          width: 100%;
          // border-right: 1px solid #808080;

          .kuanshitu {
            .image-list {
              padding: 16px 0;
              display: flex;
              flex-wrap: wrap;

              .image-item {
                width: 180px;
                height: 180px;
                margin: 10px 5px;
                border: 1px solid #ebebeb;
                object-fit: contain;
              }
            }
          }

          .gongyishuoming {
            .left {
              width: 260px;
              height: 305px;
              object-fit: contain;
            }

            .right {
              padding: 10px 20px;
            }
          }

          .mianliao-cell {
            width: 100%;

            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 14px;
              table-layout: fixed;
              border: 1px solid #e5e5e5;
            }

            tr {
              border-bottom: 1px solid #e5e5e5;
            }

            th:first-child,
            td:first-child {
              width: 75px;
            }

            th:nth-child(2),
            td:nth-child(2) {
              width: 240px !important;
              text-align: center;
              overflow: hidden;

              .table-info {
                display: flex;
                align-items: center;
                column-gap: 3px;
                width: 100%;
                font-size: 12px;

                .fa-img {
                  width: 60px;
                  height: 60px;
                  object-fit: contain;
                }

                .text {
                  display: flex;
                  align-content: space-around;
                  align-items: center;
                  flex-wrap: wrap;

                  .fa-name {
                    width: 100%;
                    font-weight: bold;
                    text-align: left;
                    line-height: 1.5;
                  }

                  .fa-key {
                    width: 100%;
                    line-height: 1.5;
                    text-align: left;
                  }
                }
              }
            }
            td:nth-child(3),
            th:nth-child(3) {
              width: 120px;
            }
            td:nth-child(4),
            td:nth-child(5),
            th:nth-child(4),
            th:nth-child(5) {
              width: 150px;
            }
            td:nth-child(6),
            th:nth-child(6) {
              width: 200px;
            }

            td:nth-child(7),
            th:nth-child(7) {
              width: 130px;
            }

            th,
            td {
              // border: 1px solid #ddd;
              padding: 8px;
              width: auto;
              min-width: 150px;
              max-width: none;
              text-align: center;
              white-space: normal;
              line-height: 1.5;
              word-break: break-all;
              overflow-x: hidden;

              .colors {
                display: flex;
                align-items: center;
                justify-content: center;
                column-gap: 3px;

                .color-image {
                  width: 40px;
                  height: 40px;
                }

                .color-name {
                  font-size: 12px;
                }
              }
            }
          }

          .fuliao-cell {
            table {
              width: 100%;
              border-collapse: collapse;
              font-size: 14px;
              table-layout: fixed;
              border: 1px solid #e5e5e5;
            }

            tr {
              border-bottom: 1px solid #e5e5e5;
            }

            th:first-child,
            td:first-child {
              width: 75px;
            }

            th:nth-child(2) {
              text-align: center !important;
            }

            th:nth-child(2),
            td:nth-child(2) {
              width: 330px;
              text-align: left;
              overflow: hidden;

              .product-info {
                display: flex;
                align-items: center;
                column-gap: 3px;
                width: 100%;
                font-size: 12px;

                .fa-img {
                  width: 60px;
                  height: 60px;
                  object-fit: contain;
                }

                .text {
                  display: flex;
                  align-content: space-around;
                  align-items: center;
                  flex-wrap: wrap;

                  .fa-name {
                    width: 100%;
                    font-weight: bold;
                    text-align: left;
                    line-height: 1.5;
                  }

                  .fa-key {
                    width: 100%;
                    line-height: 1.5;
                  }
                }
              }
            }

            td:nth-child(3),
            th:nth-child(3) {
              width: 120px;
            }

            td:nth-child(4),
            th:nth-child(4),
            td:nth-child(5),
            th:nth-child(5) {
              width: 150px;
            }

            td:nth-child(6),
            th:nth-child(6) {
              width: 200px;
            }

            th,
            td {
              // border: 1px solid #ddd;
              padding: 8px;
              width: auto;
              min-width: 150px;
              max-width: none;
              text-align: center;
              white-space: normal;
              line-height: 1.5;
              word-break: break-all;
              overflow-x: hidden;

              .fuliao-colors {
                display: flex;
                align-items: center;
                justify-content: center;
                column-gap: 3px;

                .fuliao-color {
                  width: 40px;
                  height: 40px;
                }

                .fuliao-color-name {
                  font-size: 12px;
                }
              }
            }
          }
        }

        .right {
          width: 380px;

          .file-item {
            display: block;
            margin: 10px 0;
          }

          .c-item {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: left;
            margin: 10px 0;

            img {
              width: 45px;
              height: 45px;
              margin-right: 20px;
              object-fit: contain;
            }

            span {
            }

            p {
              width: 100%;
              margin-top: 10px;
              padding: 10px;
              background: #fafafa;
              border-radius: 5px;
            }
          }
        }
      }
    }

    .other-file-cell {
      .file-list {
        display: flex;
        flex-wrap: wrap;
        justify-content: flex-start;
        align-items: center;

        .file-item {
          width: 330px;
          height: 42px;
          line-height: 42px;
          background: #fafafa;
          padding: 0 10px;
          margin: 5px 10px;
        }
      }
    }
  }

  .table {
    width: 100%;
    table-layout: fixed;
    text-align: center;
    border-collapse: collapse;
    display: block;
    overflow-x: scroll;
    white-space: nowrap;
    border-right: 1px solid #e2e5e9;
    box-shadow: 2px 0 4px -1px rgba(0, 0, 0, 0.1);

    th,
    td {
      box-sizing: border-box;
    }

    th:first-child,
    td:first-child {
      position: sticky;
      left: 0;
      z-index: 10;
      background: #f8f8f9;
    }

    .size {
      width: 160px;
    }
    .color {
      width: 130px;
    }

    .complete {
      width: 130px;
    }
    .input {
      text-align: center;
      outline: none;
      border: 1px solid #e2e5e9;
      width: 100%;
    }

    th {
      padding: 0 5px;
      height: 50px;
      line-height: 50px;
      background: #f8f8f9;
      border: 1px solid #e2e5e9;

      &.color {
        color: #fa3d5a;
      }
      .icon-edit {
        width: 12px;
        height: 12px;
        margin: 0 10px;
      }
    }

    td {
      padding: 2px 5px;
      height: 50px;
      line-height: 50px;
      border: 1px solid #e2e5e9;
      font-size: 15px;
      .icon-edit {
        width: 12px;
        height: 12px;
        margin: 0 10px;
      }
    }
  }

    // 品牌选择样式
    .brand-select-section {
      margin-top: 15px;
      display: flex;
      align-items: center;

      .brand-label {
        width: 80px;
        font-weight: bold;
        color: #333;
        font-size: 14px;
      }

      .brand-select {
        padding: 8px 12px;
        border: 1px solid #d9d9d9;
        border-radius: 6px;
        font-size: 14px;
        color: #333;
        min-width: 200px;
        cursor: pointer;

        &:focus {
          border-color: #fa3d5a;
          outline: none;
        }
      }
    }

    // 额外字段样式
    .extra-fields-section {
      margin-top: 30px;
      padding: 20px;
      background: #f9f9f9;
      border-radius: 8px;
      border: 1px solid #e0e0e0;
      
      .extra-field-group {
        margin-bottom: 20px;
        
        &:last-child {
          margin-bottom: 0;
        }
        
        .field-row {
          display: flex;
          align-items: flex-start;
          margin-bottom: 15px;
          
          &.upload-row {
            align-items: center;
          }
          
          .field-label {
            width: 120px;
            font-weight: bold;
            color: #333;
            font-size: 14px;
            line-height: 32px;
          }
          
          .extra-textarea {
            flex: 1;
            max-width: 400px;
            min-height: 80px;
            padding: 10px 15px;
            border: 1px solid #dad5d1;
            border-radius: 5px;
            outline: none;
            font-size: 14px;
            resize: vertical;
            font-family: inherit;
            line-height: 1.5;
            
            &:focus {
              border-color: #fa3d5a;
            }
          }
          
          /* Upload组件样式 */
          ::v-deep .ivu-upload {
            display: inline-block;
          }
          
          ::v-deep .ivu-btn {
            background: #fa3d5a;
            color: white;
            border-color: #fa3d5a;
            
            &:hover {
              background: #ff5772;
              border-color: #ff5772;
            }
          }
          
          // 自定义文件列表样式
          .custom-file-list {
            margin-top: 10px;
            max-width: 400px;
            
            .custom-file-item {
              display: flex;
              align-items: center;
              padding: 8px 12px;
              margin-bottom: 8px;
              background: #fff;
              border: 1px solid #e0e0e0;
              border-radius: 4px;
              transition: all 0.3s;
              
              &:hover {
                border-color: #fa3d5a;
                background: #fff5f6;
              }
              
              &:last-child {
                margin-bottom: 0;
              }
              
              .file-name {
                flex: 1;
                color: #333;
                font-size: 13px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              
              .file-size {
                color: #999;
                font-size: 12px;
                margin: 0 8px;
                white-space: nowrap;
              }
              
              .file-remove {
                color: #fa3d5a;
                font-size: 16px;
                transition: color 0.3s;
                
                &:hover {
                  color: #ff5772;
                }
              }
            }
          }
          
          .attachment-info {
            margin-left: 15px;
            font-size: 13px;
            color: #666;
            
            .remove-attachment {
              color: #fa3d5a;
              cursor: pointer;
              margin-left: 10px;
              
              &:hover {
                text-decoration: underline;
              }
            }
          }
        }
      }
    }


  .footer {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100px;
    background: white;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 10;
    .footer-btn-wrap {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .price-wrap {
        color: #333333;
        font-size: 16px;
        position: relative;

        .shu {
          margin: 0 10px;
        }

        .money1 {
          color: #fa3d5a;
        }

        .money2 {
          color: #fa3d5a;
          font-weight: bold;
          font-size: 20px;
        }

        .btn-detail {
          color: #808080;
          margin: 0 35px;
          font-size: 14px;
          cursor: pointer;
        }

        .detail-modal {
          background: white;
          box-shadow: 0px 0px 20px 0px #a6a6a6;
          z-index: 100;
          position: absolute;
          bottom: 40px;
          right: 0;
          background: white;
          border-radius: 10px;
          padding: 15px;
          width: 240px;

          .p-list {
            .p-item {
              display: flex;
              justify-content: space-around;
              font-size: 14px;
              margin: 10px 0;

              .left {
                font-weight: bold;
                width: 50%;
              }

              .right {
                text-align: right;
                width: 50%;
                color: #fa3d5a;
                font-weight: bold;
              }
            }
          }
        }
      }

      .btn {
        height: 38px;
        line-height: 38px;
        border-radius: 19px;
        font-size: 14px;
        padding: 0 20px;
        cursor: pointer;

        &.btn-confirm {
          width: 200px;
          background: #fa3d5a;
          color: white;
          text-align: center;
        }

        &.btn-back {
          width: 120px;
          margin-right: 20px;
          background: #ebebeb;
          color: #1c1f23;
          text-align: center;
        }
      }
    }

    .tips {
      width: 100%;
      text-align: center;
      font-size: 12px;
      margin-top: 10px;
      color: red;
    }
  }

  .popup {
    padding: 20px;
    .title {
      font-size: 18px;
      font-weight: bold;
      color: #1a1a1a;
      text-align: center;
    }

    .color-list {
      height: 420px;
      overflow-y: scroll;
      border: 1px solid #e0e0e0;
      border-radius: 10px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      align-content: flex-start;
      .color-item {
        position: relative;
        margin: 5px 10px;
        padding-right: 10px;
        display: flex;
        justify-content: space-around;
        align-items: center;
        column-gap: 5px;
        background: #f5f5f5;
        width: 90px;
        height: 38px;
        border-radius: 5px;
        .color-name {
          flex: 1;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
        }
        .img {
          width: 26px;
          height: 26px;
          flex-shrink: 0;
          &.icon-del {
            position: absolute;
            top: 3px;
            right: 3px;
            width: 16px;
            height: 16px;
            z-index: 100;
          }
        }
        &.active {
          border: 1px solid #fa3d5a;
        }
      }
    }

    .group-list {
      margin: 10px 0;
      width: 200px;
      height: 40px;
      line-height: 40px;
      padding: 5px 10px;
    }
    .size-list {
      height: auto;
    }

    .form-group {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 10px 0;
      .label {
        background: #e2e5e9;
        width: 140px;
        height: 51px;
        line-height: 51px;
        text-align: center;
        font-size: 14px;
        font-weight: bold;
      }
      .input {
        width: 320px;
        height: 51px;
        line-height: 51px;
        outline: none;
        border: 1px solid #e2e5e9;
        padding: 0 20px;
      }
      .btn-add {
        margin-left: -96px;
        width: 88px;
        height: 36px;
        line-height: 36px;
        color: white;
        background: #fa3d5a;
        border-radius: 18px;
        text-align: center;
      }
    }

    .tip {
      color: #808080;
      span {
        color: #fa3d5a;
      }
    }

    .btn-modify {
      margin: 20px auto;
      width: 150px;
      height: 38px;
      line-height: 38px;
      color: white;
      font-size: 14px;
      background: #000000;
      border-radius: 5px;
      text-align: center;
    }
  }
}
</style>
